// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"185":"5cfae1a9","446":"4baeb2a9","541":"8394de87","808":"27f3b5a8","832":"98cc6d7f"}[chunkId] + ".css";
};